import React from "react";
import { useParams } from "react-router-dom";
import { useCustomerTierQuery } from "@queries/customers";

export default function CustomerTierTab() {
  const { id } = useParams();
  const { data, isLoading } = useCustomerTierQuery(id);
  const tier = data?.data ?? null;

  return (
    <>
      <div className="title">Customer Tier</div>
      {isLoading && <div>Loading…</div>}
      {!isLoading && (
        <>
          <div>{tier?.tier || "No orders last year"}</div>
          <div>Average Order value : {Number(tier?.avg_last_year || 0).toFixed(2)}</div>
          <div>Total Order Value : {Number(tier?.total_last_year || 0).toFixed(2)}</div>

          <div className="oc-table-wrap" style={{marginTop:12}}>
            <table className="oc-table">
              <thead>
                <tr><th>Order type</th><th>Orders Count</th></tr>
              </thead>
              <tbody>
                {(tier?.by_type_last_year || []).map(r => (
                  <tr key={r.order_type}>
                    <td>{r.order_type}</td>
                    <td className="oc-mono">{r.orders}</td>
                  </tr>
                ))}
                {(!tier || (tier.by_type_last_year || []).length === 0) && (
                  <tr><td colSpan={2} style={{textAlign:"center",padding:24}}>No results!</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}

